/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Settings_Required_ErrorInputs */



/**
* | output |
* | --- |
* | "Settings object is required" |
*
* @param {Iframe_Remote_Settings_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_settings_required_error = /** @type {((inputs?: Iframe_Remote_Settings_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Settings_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Objet de parametres requis")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Einstellungsobjekt ist erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'oggetto Impostazioni è obbligatorio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объект настроек обязателен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requiere el objeto de configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要设置对象。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定オブジェクトが必要です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स ऑब्जेक्ट आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O objeto de configurações é obrigatório.")
	return /** @type {LocalizedString} */ ("Settings object is required")
});